import { ApiKeyConst, yupLocalized } from "@ryde/shared";

export enum ApiKeyCreateForm {
  companyId = "companyId",
  name = "name",
  roleId = "roleId",
  ttlDays = "ttlDays",
}

export interface IApiKeyCreateForm {
  [ApiKeyCreateForm.companyId]: number | string;
  [ApiKeyCreateForm.name]: string;
  [ApiKeyCreateForm.roleId]: number | string;
  [ApiKeyCreateForm.ttlDays]: number | string;
}

export const apiKeyCreateValidationSchema = {
  [ApiKeyCreateForm.companyId]: yupLocalized.number().required(),
  [ApiKeyCreateForm.name]: yupLocalized
    .string()
    .trim()
    .required()
    .max(ApiKeyConst.NAME_MAX_LENGTH),
  [ApiKeyCreateForm.roleId]: yupLocalized.number().required(),
  [ApiKeyCreateForm.ttlDays]: yupLocalized
    .number()
    .integer()
    .min(ApiKeyConst.MIN_TTL_DAYS)
    .max(ApiKeyConst.MAX_TTL_DAYS)
    .required(),
};
